import type { Asset, Entry } from 'contentful';

type IncludesType = {
    Entry?: Entry[];
    Asset?: Asset[];
};

function isLinkToEntry(value): value is { sys: { id: string; type: 'Link'; linkType: 'Entry' } } {
    return (
        typeof value === 'object' &&
        value !== null &&
        'sys' in value &&
        value.sys?.type === 'Link' &&
        value.sys?.linkType === 'Entry'
    );
}

function getLinkedEntries(entity: Entry, includes: IncludesType) {
    const linkedEntries: Entry[] = [];

    for (const field in entity.fields) {
        const value = entity.fields[field];

        if (Array.isArray(value)) {
            for (const item of value) {
                if (isLinkToEntry(item)) {
                    const linkedEntry = includes.Entry?.find((e) => e.sys.id === item.sys.id);
                    if (linkedEntry) {
                        linkedEntries.push(linkedEntry);
                    }
                }
            }
        } else if (isLinkToEntry(value)) {
            const linkedEntry = includes.Entry?.find((e) => e.sys.id === value.sys.id);
            if (linkedEntry) {
                linkedEntries.push(linkedEntry);
            }
        }
    }

    return linkedEntries;
}

export default function checkRecursion(entity: Entry, includes: IncludesType, visited: Set<string> = new Set()) {
    if (visited.has(entity.sys.id)) {
        return true; // Recursion detected
    }

    visited.add(entity.sys.id);

    const linkedEntries = getLinkedEntries(entity, includes);
    for (const linkedEntry of linkedEntries) {
        if (checkRecursion(linkedEntry, includes, visited)) {
            return true; // Recursion detected in linked entry
        }
    }

    visited.delete(entity.sys.id);
    return false; // No recursion detected
}
